// extracted by mini-css-extract-plugin
export default {"Note":"styles_Note__6K-xm","noteContent":"styles_noteContent__MC8Tu","onTop":"styles_onTop__ilore"};